function formatDifficultyLabel(level) {
    if (level == null || level === "") return "";
    const text = String(level).trim();
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

/** Puzzle title from a credit usage log row (supports common API field names). */
export function usageLogPuzzleTitle(row) {
    const title = row?.puzzleTitle ?? row?.title ?? row?.storyTitle;
    if (title == null || String(title).trim() === "") return "—";
    return String(title).trim();
}

/** Size × size label from gridSize or tileSize on a usage log row. */
export function usageLogPuzzleSize(row) {
    const size = Number(row?.gridSize ?? row?.tileSize ?? row?.puzzleSize ?? 0);
    if (!Number.isFinite(size) || size <= 0) return "";
    return `${size}×${size}`;
}

/** Combined size and difficulty, e.g. "4×4 · Medium". */
export function formatUsageLogSizeDifficulty(row) {
    const sizePart = usageLogPuzzleSize(row);
    const diffPart = formatDifficultyLabel(row?.difficultyLevel ?? row?.difficulty);
    if (sizePart && diffPart) return `${sizePart} · ${diffPart}`;
    return sizePart || diffPart || "—";
}
